// ----------------------------------------------------------------------

const MuiLink = {
  // ▼▼▼▼▼▼▼▼ ⚙️ PROPS ▼▼▼▼▼▼▼▼
  defaultProps: {
    underline: 'hover',
  },
};

/* **********************************************************************
 * 🚀 Export
 * **********************************************************************/
export const link = {
  MuiLink,
};
